import type { BadgeType, MainCategoriesType, ShortGameZipType } from '@/types'
import { shuffle } from '@/utils/helpers'

const PURCHASE_DISABLED_TOP_GAMES_HRUS: Record<string, true> = {
    'piece-of-cake-merge--bake': true,
    'vega-mix-2-adventure': true,
    'chess-online-multiplayer': true,
    'mr-racer-car-racing': true,
}

type TopGame = {
    hru: string
    title: string
    likes: string
    icon: string
    color: string
    badges?: BadgeType[]
}

export const topGames: TopGame[] = [
    {
        hru: 'age-of-tanks-warriors-td-war',
        title: 'Age of Tanks Warriors: TD War',
        likes: '26k',
        icon: 'https://playgama.com/cdn-cgi/imagedelivery/LN2S-4p3-GgZvEx3IPaKUA/63af6aa0-344f-46ca-1cfb-885f61230800/thumb',
        color: '#3fe1f1',
    },
    {
        hru: 'bubble-blast',
        title: 'Bubble Blast',
        likes: '11k',
        icon: 'https://playgama.com/cdn-cgi/imagedelivery/LN2S-4p3-GgZvEx3IPaKUA/072b1672-c854-45fb-b387-a86bc0474500/thumb',
        color: '#ff1f00',
        badges: ['top'],
    },
    {
        hru: 'chess-online-multiplayer',
        title: 'Chess Online Multiplayer',
        likes: '6k',
        icon: 'https://playgama.com/cdn-cgi/imagedelivery/LN2S-4p3-GgZvEx3IPaKUA/9e2eb475-4c3b-45cf-4071-79fd367be100/thumb',
        color: '#3fe1f1',
    },
    {
        hru: 'deadly-descent',
        title: 'Deadly Descent',
        likes: '7k',
        icon: 'https://playgama.com/cdn-cgi/imagedelivery/LN2S-4p3-GgZvEx3IPaKUA/1e2ebc7e-1577-4b9e-33ed-f4a931f09900/thumb',
        color: '#3fe1f1',
    },
    {
        hru: 'fruit-merge-playgama',
        title: 'Fruit Merge: Juicy Drop Game',
        likes: '3k',
        icon: 'https://playgama.com/cdn-cgi/imagedelivery/LN2S-4p3-GgZvEx3IPaKUA/a0b73bf8-debb-4b65-5362-75338ff42700/thumb',
        color: '#1aff00',
        badges: ['top'],
    },
    {
        hru: 'gangster-island-crime-city',
        title: 'Gangsta Island: Crime City',
        likes: '13k',
        icon: 'https://playgama.com/cdn-cgi/imagedelivery/LN2S-4p3-GgZvEx3IPaKUA/e281d982-787b-4b3e-81eb-3eb384f59500/thumb',
        color: '#3fe1f1',
    },
    {
        hru: 'good-sort-master',
        title: 'Good Sort Master: Triple Match',
        likes: '5k',
        icon: 'https://playgama.com/cdn-cgi/imagedelivery/LN2S-4p3-GgZvEx3IPaKUA/f79d3c24-1727-4493-bf12-5a9c29757500/thumb',
        color: '#d07ffe',
        badges: ['top'],
    },
    {
        hru: 'hidden-object-my-hotel',
        title: 'Hidden Object: My Hotel',
        likes: '8k',
        icon: 'https://playgama.com/cdn-cgi/imagedelivery/LN2S-4p3-GgZvEx3IPaKUA/489f536f-a5ed-4f29-5dd9-1f19a184d000/thumb',
        color: '#b03ff1',
    },
    {
        hru: 'millionaire-life',
        title: 'Millionaire Life',
        likes: '18k',
        icon: 'https://playgama.com/cdn-cgi/imagedelivery/LN2S-4p3-GgZvEx3IPaKUA/bf5e280e-0b69-4e8f-46c5-f6e4eb226700/thumb',
        color: '#e7572b',
    },
    {
        hru: 'mr-racer-car-racing',
        title: 'MR RACER - Car Racing',
        likes: '5k',
        icon: 'https://playgama.com/cdn-cgi/imagedelivery/LN2S-4p3-GgZvEx3IPaKUA/68e0caf0-55ca-44f2-4e69-453b792e8100/thumb',
        color: '#3fe1f1',
        badges: ['top'],
    },
    {
        hru: 'my-town-home-family-playhouse',
        title: 'My Town Home: Family Playhouse',
        likes: '5k',
        icon: 'https://playgama.com/cdn-cgi/imagedelivery/LN2S-4p3-GgZvEx3IPaKUA/49e71097-2be1-472c-66a5-c3ba20cb0900/thumb',
        color: '#c8ff00',
        badges: ['top'],
    },
    {
        hru: 'piece-of-cake-merge--bake',
        title: 'Piece of Cake: Merge & Bake',
        likes: '5k',
        icon: 'https://playgama.com/cdn-cgi/imagedelivery/LN2S-4p3-GgZvEx3IPaKUA/e7e6c5df-86fb-4f99-561a-22ab0db54c00/thumb',
        color: '#fff200',
        badges: ['top'],
    },
    {
        hru: 'snake-2048-64be-1',
        title: 'Snake 2048',
        likes: '3k',
        icon: 'https://playgama.com/cdn-cgi/imagedelivery/LN2S-4p3-GgZvEx3IPaKUA/4d6d283c-b5af-4a82-0257-27d5725b9100/thumb',
        color: '#3fe1f1',
    },
    {
        hru: 'speed-per-click-obby',
        title: 'Speed per Click: Obby',
        likes: '3k',
        icon: 'https://playgama.com/cdn-cgi/imagedelivery/LN2S-4p3-GgZvEx3IPaKUA/61b5ec99-a975-4899-e561-237cea4d3600/thumb',
        color: '#3fe1f1',
    },
    {
        hru: 'tb-world',
        title: 'TB World',
        likes: '15k',
        icon: 'https://playgama.com/cdn-cgi/imagedelivery/LN2S-4p3-GgZvEx3IPaKUA/91526479-de72-4994-0d17-56cf8018ce00/thumb',
        color: '#1aff00',
        badges: ['hot'],
    },
    {
        hru: 'vega-mix-2-adventure',
        title: 'Vega Mix 2: Adventure',
        likes: '10k',
        icon: 'https://playgama.com/cdn-cgi/imagedelivery/LN2S-4p3-GgZvEx3IPaKUA/1e9bd51b-3b6d-40d3-490f-d44ab1a9d900/thumb',
        color: '#3fe1f1',
        badges: ['top'],
    },
    {
        hru: 'hero-defense-king',
        title: 'Hero Defense King',
        likes: '2k',
        icon: 'https://playgama.com/cdn-cgi/imagedelivery/LN2S-4p3-GgZvEx3IPaKUA/552fa720-8934-4eab-0acf-64fa3ebe3f00/thumb',
        color: '#ff6b00',
        badges: ['top'],
    },
]

function zipTopGames(game: TopGame): ShortGameZipType {
    return [game.hru, '', '', '', '', '', false, undefined, [], 'playgama', undefined]
}

export const createPlaygamaTopCategory = (isPurchaseEnabled: boolean) => {
    const filteredGames = isPurchaseEnabled
        ? topGames
        : topGames.filter((game) => !PURCHASE_DISABLED_TOP_GAMES_HRUS[game.hru])

    return {
        id: 'top_playgama' as MainCategoriesType,
        title: 'Playgama Top',
        location: {
            name: 'category',
            params: {
                hru: 'top_playgama',
            },
        },
        games: shuffle(filteredGames.map(zipTopGames)),
    }
}
